class NavMenu extends HTMLElement {
  constructor() {
    super();
    this.navOpen = this.querySelector('#NavDrawer-Open');
    this.navOpen.addEventListener('click', this.open.bind(this));
  }

  open(event) {
    event.preventDefault();
    document.querySelector('nav-drawer').style.transform = "translateX(0)";
    document.querySelector('html').classList.add('overflow-hidden');
  }

  close(event) {
    event.preventDefault();
    document.querySelector('nav-drawer').style.transform = "translateX(-100%)";
    document.querySelector('html').classList.remove('overflow-hidden');
  }
}

customElements.define('nav-menu', NavMenu)

class NavDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.target === this && evt.code === 'Escape' && this.close(evt));
    this.querySelector('#NavDrawer-closeSelf').addEventListener('click', this.close.bind(this))
  }

  close(event) {
    document.querySelector('nav-menu').close(event);
  }

  open(event) {
    document.querySelector('nav-menu').open(event);
  }
}

customElements.define('nav-drawer', NavDrawer)

class NavSubdrawer extends HTMLElement {
  constructor() {
    super();
    this.ref = this.dataset.ref;
    this.addEventListener('keyup', (evt) => evt.target === this && evt.code === 'Escape' && this.close(evt));
    document.getElementById(`nav-subdrawer-link-${this.ref}`).addEventListener('click', this.open.bind(this))
    this.querySelector(`#nav-subdrawer-closeself-${this.ref}`).addEventListener('click', this.close.bind(this))
    this.querySelector('.caret-left').addEventListener('click', this.close.bind(this))
  }

  open(event) {
    event.preventDefault();
    this.style.transform = "translateX(0)";
  }

  close(event) {
    event.preventDefault();
    this.style.transform = "translateX(-110%)";
  }
}

customElements.define('nav-subdrawer', NavSubdrawer)

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.menu = this.querySelector('ul');
    this.caretDown = this.querySelector('.caret-down');
    this.caretUp = this.querySelector('.caret-up');
    this.isOpen = false;
    this.querySelector('label').addEventListener('click', this.toggle.bind(this));
    this.addEventListener('blur', this.close.bind(this))
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.menu.style.visibility = 'visible';
    this.menu.style.opacity = 1;
    this.caretDown.classList.add('hidden');
    this.caretUp.classList.remove('hidden');
    this.isOpen = true;
    this.setFocus();
  }

  close(event = false) {
    if(event && this.contains(event.relatedTarget)) {
      return false;
    }
    this.menu.style.visibility = 'hidden';
    this.menu.style.opacity = 0;
    this.caretDown.classList.remove('hidden');
    this.caretUp.classList.add('hidden');
    this.isOpen = false;
  }

  setFocus() {
    window.setTimeout(() => this.focus(), 100);
  }
}

customElements.define('menu-drawer', MenuDrawer)

class NavMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.menu = this.querySelector('ul');
    this.caretDown = this.querySelector('.caret-down');
    this.caretUp = this.querySelector('.caret-up');
    this.isOpen = false;
    this.calcHeight()
    this.querySelector('label').addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.menu.style.height = `${this.height}px`;
    this.menu.style.opacity = 1;
    this.caretDown.classList.add('hidden');
    this.caretUp.classList.remove('hidden');
    this.isOpen = true;
  }

  close() {
    this.menu.style.height = '0';
    this.menu.style.opacity = 0;
    this.caretDown.classList.remove('hidden');
    this.caretUp.classList.add('hidden');
    this.isOpen = false;
  }

  calcHeight() {
    const clone = this.menu.cloneNode(true);
    Object.assign(clone.style, {
      overflow: 'visible',
      height: 'auto',
      maxHeight: 'none',
      opacity: '0',
      visibility: 'hidden',
      display: 'block'
    });
    this.menu.after(clone);
    this.height = clone.offsetHeight;
    clone.remove();
  }
}

customElements.define('nav-menu-drawer', NavMenuDrawer)